module.exports = __webpack_public_path__ + "img/停车场.89da9463.png";